import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import isMobileAppWebview from '../../../../../utils/is-mobile-app-webview';
import isMobileAppWithDeeplinkRedirect from '../../../../../utils/is-mobile-app';
import { getMobilePathParams } from '../../kushki/utils/kushki';
import API_URLS from '../../../../../constants/api-urls';
import { world } from '../../../../../languages';
import { QUERY_MATERIAL } from '../../../../../constants/query-params/material';
import { QUERY_PAYMENT } from '../../../../../constants/query-params/payment';
import serializeQueryParams from '../../../../../utils/url/serialize-query-params';
import { PURCHASE_FORM_MODE } from '../purchase-form.constants';

export default function useActionUrl(mode: PURCHASE_FORM_MODE, paymentOption?: string) {
    const currency = useSelector((state: RootState) => state.main.currency);
    const { paymentCart } = useSelector((state: RootState) => state.payment);
    const queryParams = serializeQueryParams();

    const [actionURL, setActionURL] = useState('');

    const getPaymentMethod = () => {
        return mode === PURCHASE_FORM_MODE.FREE
            ? (paymentCart?.usedCredits ? 'Credits' : 'Voucher')
            : (paymentOption || 'PayPal');
    };

    const getPaymentSystem = () => {
        if (PURCHASE_FORM_MODE.FREE) {
            return '';
        }

        const method = paymentOption || 'PayPal';

        return (method !== 'PayPalPlus' && method !== 'PayPal' && method !== 'Invoice')
            ? method
            : '';
    };

    useEffect(() => {
        if (!paymentCart?.loaded || !currency.loaded) {
            return;
        }

        const paymentMethod = getPaymentMethod();
        const paymentSystem = getPaymentSystem();
        const mobileParams = getMobilePathParams();

        const url = new URL(`${process.env.REACT_APP_API_URL}${API_URLS.PAYMENT_ATTEMPT}/${paymentMethod}`);

        url.searchParams.set('world', world);

        if (mode === PURCHASE_FORM_MODE.PAID) {
            url.searchParams.set('currencyCode', currency.code);
        }

        if (queryParams[QUERY_PAYMENT.ORDER_TOKEN]) {
            url.searchParams.set(QUERY_PAYMENT.ORDER_TOKEN, queryParams[QUERY_PAYMENT.ORDER_TOKEN] as string);
        }

        if (queryParams[QUERY_MATERIAL.MATERIAL_ID]) {
            url.searchParams.set(QUERY_MATERIAL.MATERIAL_ID, queryParams[QUERY_MATERIAL.MATERIAL_ID] as string);
        }

        if (paymentSystem) {
            url.searchParams.set('paymentSystem', paymentSystem);
        }

        if (isMobileAppWebview()) {
            url.searchParams.set('mobile_app', 'true');
        }

        if (isMobileAppWithDeeplinkRedirect()) {
            url.searchParams.set('deepLinkRedirect', 'true');
        }

        setActionURL(`${url.href}${mobileParams}`);
    }, [paymentCart?.loaded, currency.loaded, paymentOption, mode]);

    return actionURL;
};
